import {ObjectId} from 'bson';
import {
  AiBooleanFieldDefinitionSchema,
  AiCategoryFieldDefinitionSchema,
  AiEstimateFieldDefinitionSchema,
  AiRatingFieldDefinitionSchema,
  AiResearchFieldDefinitionSchema,
  AiTeamSizeFieldDefinitionSchema,
  CrmFieldDefinitionSchema,
  AiFieldDefinitionSchema,
  LegacyAiResearchFieldDefinitionSchema,
  LegacyAiTeamSizeFieldDefinitionSchema,
} from '../../fields/enrichment';
import {
  LinkedInIntentFieldDefinitionSchema,
  AggregatedIntentFieldDefinitionSchema,
} from '../../fields/intent';
import {ApiDefinition} from '../definitions';
import {z} from 'zod';
import {FieldDefinitionSchema} from '../../fields/types';

const creationFields = {
  id: true,
  timestamp: true,
} as const;
export const CreateFieldDefinition = {
  path: 'fieldDefinition/createFieldDefinition',
  method: 'post',
  options: {access: 'paid'},
  requestDataSchema: z.union([
    AggregatedIntentFieldDefinitionSchema.omit(creationFields),
    AiBooleanFieldDefinitionSchema.omit(creationFields),
    AiCategoryFieldDefinitionSchema.omit(creationFields),
    AiEstimateFieldDefinitionSchema.omit(creationFields),
    AiRatingFieldDefinitionSchema.omit(creationFields),
    AiResearchFieldDefinitionSchema.omit(creationFields),
    AiTeamSizeFieldDefinitionSchema.omit(creationFields),
    CrmFieldDefinitionSchema.omit(creationFields),
    LegacyAiResearchFieldDefinitionSchema.omit(creationFields),
    LegacyAiTeamSizeFieldDefinitionSchema.omit(creationFields),
    LinkedInIntentFieldDefinitionSchema.omit(creationFields),
  ]),
  responseDataSchema: FieldDefinitionSchema,
} satisfies ApiDefinition;

export const DeleteFieldDefinition = {
  path: 'fieldDefinition/deleteFieldDefinition',
  method: 'post',
  options: {access: 'admin'},
  requestDataSchema: z.object({
    fieldId: z.instanceof(ObjectId),
  }),
  responseDataSchema: z.void(),
} satisfies ApiDefinition;

export const SaveFieldDefinition = {
  path: 'fieldDefinition/saveFieldDefinition',
  method: 'post',
  options: {access: 'paid'},
  requestDataSchema: z.object({
    fieldDefinition: AiFieldDefinitionSchema,
  }),
  responseDataSchema: AiFieldDefinitionSchema,
} satisfies ApiDefinition;
